// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Button } from '@mui/material';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import { useOAuthCallback } from './use-oauth-callback';

export const OAuthCallback = defineComponent({
  displayName: 'OAuthCallback',
  useSetup: useOAuthCallback,
  View: ({ error, isLoading, login, t }) => (
    <div className="mt-48 flex flex-col items-center justify-center px-4">
      <div className="mx-auto flex max-w-sm flex-col items-center justify-center gap-6 text-center">
        <h1 className="text-xl font-semibold text-title-alt">
          {error
            ? t('auth.callback.error-title', { ns: 'auth' })
            : t('auth.callback.signing-in', { ns: 'auth' })}
        </h1>
        {isLoading && (
          <div className="h-10 w-10 animate-spin rounded-full border-2 border-primary border-t-transparent" />
        )}
        <p className="mx-auto max-w-xs text-center text-title-alt">
          {isLoading
            ? t('auth.callback.signing-in', { ns: 'auth' })
            : error ?? t('auth.callback.signing-in', { ns: 'auth' })}
        </p>
        {error && (
          <Button color="secondary" onClick={() => login()}>
            {t('auth.callback.try-again', { ns: 'auth' })}
          </Button>
        )}
      </div>
    </div>
  ),
});
